(function () {
    'use strict';
    app.controller('usermanagementController', ['$filter', '$scope', '$location', '$cookies', 'progressBarService', '$rootScope', '$timeout', '$routeParams', 'userManagementService', 'CommonService', 'profileservice', 'userAccountService', function ($filter, $scope, $location, $cookies, progressBarService, $rootScope, $timeout, $routeParams, userManagementService, commonService, profileservice, userAccountService) {

        if ($cookies.get('TokenInfo') == undefined || localStorage.getItem('appInfo') == undefined || getLocalValue('userRole') != 'SAdmin') {
            $location.path('/login');
            return false;
        }

        $scope.isSAdmin = getLocalValue('userRole') == 'SAdmin' ? true : false;

        $scope.isUserManagementPage = true;

        var hideMessage = function () {
            $scope.isError = false;
            $scope.isSuccess = false;
            $scope.message = ''

            $scope.isModalError = false;
            $scope.isModalSuccess = false;
            $scope.modalMessage = '';
        }

        $scope.reset = function () {
            hideMessage();
            $scope.isAccordionHide = true;
            $scope.AffiliationAdmins = [];
            $scope.users = [];
            $scope.pagination = {
                currentPage: 1,
                itemsPerPage: 10,
                totalRows: 0,
                sortBy: 'eSpectraFullName',
                reverse: false
            }

            $scope.models = {
                name: '',
                email: '',
                affiliation: '',
                premium: true,
                restricted: true,
                free: true,
                active: true,
                deactivated: true,
                suspended: true,
                Unactivated: true,
                admininstrator: true,
                Deprecated: false,
                individualAccount: true,
                institutionAccount: true
            }
        }

        $scope.setPage = function (currentPage) {
            $scope.pagination.currentPage = currentPage;
            $scope.getData();
        }

        $scope.sort = function (sortBy) {
            if ($scope.users.length > 0) {
                $scope.pagination.sortBy = sortBy;
                $scope.pagination.currentPage = 1;
                $scope.pagination.reverse = !$scope.pagination.reverse;
                $scope.getData();
            }
        }

        $scope.reset();

        $scope.getData = function (click) {
            progressBarService.showProgressBar();
            hideMessage();
            if (click == "search") {
                $scope.users = [];
                $scope.pagination.currentPage = 1;
                $scope.pagination.sortBy = 'eSpectraFullName';
                $scope.pagination.reverse = false;
            }

            var data = {
                PageNo: $scope.pagination.currentPage,
                SortBy: $scope.pagination.sortBy,
                Reverse: $scope.pagination.reverse ? 'desc' : 'asc',
                eSpectraFullName: $scope.models.name,
                eSpectraEmail: $scope.models.email,
                eSpectraPrimaryAffiliationName: $scope.models.affiliation,
                PremiumType: $scope.models.premium ? '1' : '0',
                Restricted: $scope.models.restricted ? '1' : '0',
                Free: $scope.models.free ? '1' : '0',
                Active: $scope.models.active ? 'active' : '0',
                Deactivated: $scope.models.deactivated ? 'deactivated' : '0',
                Suspended: $scope.models.suspended ? 'suspended' : '0',
                Unactivated: $scope.models.Unactivated ? 'pending' : '0',
                Administrator: $scope.models.admininstrator ? '1' : '0',
                Deprecated: $scope.models.Deprecated ? 'deprecated' : '0',
                IndividualAccount: $scope.models.individualAccount ? '1' : '0',
                InstitutionAccount: $scope.models.institutionAccount ? '1' : '0'
            }

            userManagementService.getData(data).then(function (response) {
                $scope.isAccordionHide = false;
                if (response != null && response.data.message != undefined) {
                    $scope.message = response.data.message;
                    $scope.isError = true;
                    $scope.isSuccess = false;
                }
                else {

                    angular.forEach(response.data, function (value, index) {
                        response.data[index].editable = false;
                        response.data[index].eSpectraUserStatus = response.data[index].eSpectraUserStatus == 'Pending' ? 'Unactivated' : response.data[index].eSpectraUserStatus;
                        response.data[index].eSpectraUserRoleStatus = response.data[index].eSpectraUserRoleStatus == 'Pending' ? 'Unactivated' : response.data[index].eSpectraUserRoleStatus;
                    });
                    $scope.users = response.data;
                    if (response.data.length > 0) {
                        $scope.pagination.totalRows = response.data[0].totalRows;
                    }
                }
                $scope.getStatusData();
            });
        }

        $scope.validatePassword = function (event) {
            commonService.validatePassword($scope, event);
        }

        $scope.checkLength = function (password, event) {
            if (password.length > 20) {
                event.preventDefault();
            } else {
                if (password.length < 6) {
                    $('#newPassword').addClass('border-red');
                } else {
                    $('#newPassword').removeClass('border-red');
                }
            }
        }

        $scope.getStatusData = function () {
            userManagementService.getStatusData().then(function (response) {
                if (response != null && response.data.message != undefined) {

                    $scope.message = response.data.message;
                    $scope.isError = true;
                    $scope.isSuccess = false;
                }
                else {
                    $scope.status = response.data;
                    //$scope.getStateByCountryID();
                }
                $scope.closeEditUserProfileModal();
                progressBarService.hideProgressBar();
            });
        }

        $scope.displayDownloadReportPopup = function () {
            $scope.abbreviatedReport = true;
            $scope.fullReport = false;
            $('#downloadReportDialog').modal({ backdrop: 'static', keyboard: false });
        }

        var disableProfileForm = function (value) {
            $scope.disableFirstName = value;
            $scope.disableLastName = value;
            $scope.disableAffiliation = value;
            $scope.disableUserStatus = value;
            $scope.disableRoleType = value;
            $scope.disableChangePassword = value;
            $scope.disableConfirmPassword = value;
            $scope.disableSaveBtn = value;
        }

        $scope.displayEditProfileModal = function (index, user) {
            $scope.personId = user.eSpectraPersonID;
            $scope.modalMessage = '';
            disableProfileForm(false);
            $scope.isAffiliationDivActive = false;
            $scope.userStatusHistoryDetails = [];
            $('.clearAffiliation').addClass('hide');
            $scope.selectedInstitute = {
                InstitutionId: 0,
                InstitutionName: '',
                isAffiliationExists: false,
                userDefinedAffiliation: ''
            };
            $scope.eSpectraAdminNote = "";
            if (user.eSpectraUserStatus == "Deprecated") {
                disableProfileForm(true);
            }
            var element = document.getElementById('suspensionReasonTextArea');
            if (element != null && element.classList.contains("border-red")) {
                element.classList.remove("border-red");
            }
            $scope.deletedSubPackIds = '';
            $scope.isShowAddSubPackIcon = true;
            $scope.isShowRemoveSubPackIcon = false;
            $scope.isCommentError = false;
            $scope.isWrongExpiryDate = false;
            $scope.errorMessageForWrongExpiryDate = "";
            $scope.purchaseDetailscurrentPage = 0;
            $scope.commentDetailsCurrentPage = 0;
            $scope.purchaseDetailsPageSize = 5;
            $scope.commentDetailsPageSize = 3;
            $scope.activeTab = 1;
            $scope.profileForm.$setPristine();
            $scope.profileForm.$setUntouched();
            $scope.isUserStatusChanged = false;
            $scope.isTopAdminNoteUpdated = false;
            $scope.deletedComments = '';
            $scope.updatedAdminNoteIndex = '';

            //angular.forEach($scope.userStatusHistoryDetails, function (value, key) {
            //    $scope.userStatusHistoryDetails[key].isShowEditButton = true;
            //    $scope.userStatusHistoryDetails[key].isShowDeleteButton = true;
            //});

            userAccountService.getAccountData(user.eSpectraEmail).then(function (response) {
                if (response != null && response.data.message != undefined) {
                    $scope.message = response.data.message;
                    $scope.isError = true;
                    $scope.isSuccess = false;
                }
                else {
                    $scope.profileData = response.data;
                    $scope.profileData.index = index;
                    $scope.profileData.InstitutionId = $scope.profileData.eSpectraPrimaryAffiliationID;
                    $scope.profileData.currentUserSelectedAdminStatus = $scope.profileData.eSpectraUserRoleStatus;
                    $scope.profileData.eSpectraSelectedUserStatus = $scope.profileData.eSpectraPartyStatus == 'Pending' ? 'Active' : $scope.profileData.eSpectraPartyStatus;
                    $scope.profileData.InstitutionName = $scope.profileData.eSpectraPrimaryAffiliationName;
                    $scope.profileData.registeredPassword = '';
                    $scope.profileData.confirmPassword = '';
                    $scope.profileData.premiumType = user.premiumType;
                    $scope.disableAffiliation = $scope.profileData.eSpectraSelectedUserStatus.toLowerCase() == 'deprecated' || $scope.profileData.isTeamMember == 1 ? true : false;
                    $scope.profileData.isKratosData = $scope.profileData.isKratosData == 1 ? true : false;
                    if (user.eSpectraUserRole.toLowerCase() == 'primary administrator') {
                        $scope.profileData.eSpectraUserRole = user.eSpectraUserRole;
                    } else {
                        $scope.profileData.eSpectraUserRole = $scope.profileData.eSpectraUserRole == 'IAdmin' ? 'Institution Administrator' : $scope.profileData.eSpectraUserRole;
                        $scope.profileData.eSpectraUserRole = $scope.profileData.eSpectraUserRole == 'SAdmin' ? 'System Administrator' : $scope.profileData.eSpectraUserRole;
                    }
                    $scope.profileData.currentUserSelectedRoleType = $scope.profileData.eSpectraUserRole;
                    $scope.getUserSubPackPurchaseDetails();

                }
            });
        }

        $scope.getCurrentDateTime = function () {
            var today, dd, mm, yyyy, currentDate, currentTime;
            today = new Date();
            dd = today.getDate();
            mm = today.getMonth() + 1;
            yyyy = today.getFullYear();
            $scope.currentSeconds = today.getSeconds();
            if (dd < 10) {
                dd = '0' + dd;
            }
            if (mm < 10) {
                mm = '0' + mm;
            }
            $scope.currentDate = mm + '-' + dd + '-' + yyyy;
            $scope.databaseDate = yyyy + '-' + mm + '-' + dd;
            $scope.currentTime = today.getHours() + ":" + today.getMinutes();
        }

        $scope.getNewStatusDetailsModel = function () {
            $scope.getCurrentDateTime();
            $scope.newStatusDetailsModel = {
                adminFullName: getLocalValue('fullName'),
                userStatus: $scope.profileData.eSpectraSelectedUserStatus,
                statusDate: $scope.currentDate + " " + $scope.currentTime,
                isShowCommentBox: true,
                isShowCommentError: false,
                isShowTick: true,
                isShowEditButton: false,
                isShowDeleteButton: true,
                adminNote: "",
                adminNoteId: 0,
                newAdminNote: ""
            };
        }

        $scope.checkSelectedStatus = function (eSpectraSelectedUserStatus) {
            $scope.activeTab = 2;
            $scope.getCurrentDateTime();
            $scope.userStatusHistoryDetails[0].userStatus = eSpectraSelectedUserStatus;
            $scope.userStatusHistoryDetails[0].statusDate = $scope.currentDate + " " + $scope.currentTime;
        }

        $scope.getUserSubPackPurchaseDetails = function () {
            userManagementService.getUserSubPackPurchaseDetails($scope.profileData.eSpectraPersonID).then(function (response) {

                if (response != null && response.data.message != undefined) {

                    $scope.modalMessage = response.data.message;
                    $scope.isModalError = true;
                    $scope.isModalSuccess = false;
                } else {
                    $scope.userSubpackPurchaseDetails = response.data.userSubPackDetails;
                    $scope.userCurrentSubscription = response.data.activeSubpack;
                    if ($scope.userSubpackPurchaseDetails.length > 0) {
                        $scope.userSubpackPurchaseDetails[0].isExpiryDateEditable = false;
                        $scope.userSubpackPurchaseDetails[0].isExpiryDateUpdated = false;
                    }
                    $scope.isAutorenewal = $scope.userCurrentSubscription.eSpectraRecurringBillFlag;
                    $('#editUserProfileModal').modal('show');

                    $scope.getUserStatusCommentHistory();
                }
            });
        }

        $scope.getUserStatusCommentHistory = function () {
            var data = {
                eSpectraPersonID: $scope.personId
            }
            $scope.getNewStatusDetailsModel();
            userManagementService.getUserStatusHistory(data).then(function (response) {
                if (response != null && response.data.message != undefined) {
                    if (response.data.message.toLowerCase() == 'no data found') {
                        $scope.userStatusHistoryDetails.unshift($scope.newStatusDetailsModel);
                        $scope.isUserStatusChanged = true;
                        $scope.isNewStatusModelAdded = true;
                    }
                }
                else {
                    $scope.userStatusHistoryDetails = response.data;
                    angular.forEach($scope.userStatusHistoryDetails, function (value, key) {
                        $scope.userStatusHistoryDetails[key].isShowCommentBox = false;
                        $scope.userStatusHistoryDetails[key].isShowCommentError = false;
                        $scope.userStatusHistoryDetails[key].isShowTick = false;
                        $scope.userStatusHistoryDetails[key].isShowEditButton = true;
                        $scope.userStatusHistoryDetails[key].isShowDeleteButton = true;
                        $scope.userStatusHistoryDetails[key].newAdminNote = $scope.userStatusHistoryDetails[key].adminNote;
                    });
                    $scope.userStatusHistoryDetails.unshift($scope.newStatusDetailsModel);
                    $scope.isNewStatusModelAdded = true;
                }

                progressBarService.hideProgressBar();
            });
        }

        $scope.setIndividualStatusComment = function (index) {
            var element = document.getElementsByClassName('admin-status-' + index);
            if (!$scope.userStatusHistoryDetails[index].isShowCommentError) {
                if ($scope.userStatusHistoryDetails[index].newAdminNote == "") {
                    $(element).addClass('border-red');
                } else {
                    $(element).removeClass('border-red');
                    index = ($scope.commentDetailsCurrentPage * 3) + index
                    $scope.updatedAdminNoteIndex = index;
                    $scope.userStatusHistoryDetails[index].adminNote = $scope.userStatusHistoryDetails[index].newAdminNote == "" ? "n/a" : $scope.userStatusHistoryDetails[index].newAdminNote;
                    $scope.getCurrentDateTime();
                    $scope.userStatusHistoryDetails[index].statusDate = $scope.currentDate + " " + $scope.currentTime;
                    if ($scope.profileData.eSpectraAdminNote != $scope.userStatusHistoryDetails[index].adminNote) {
                        $scope.profileData.eSpectraAdminNoteLastUpdateTS = $scope.userStatusHistoryDetails[index].statusDate;
                        $scope.isTopAdminNoteUpdated = true;
                    } else {
                        $scope.profileData.eSpectraAdminNoteLastUpdateTS = $scope.userStatusHistoryDetails[index].statusDate;
                    }
                    $scope.profileData.eSpectraAdminNote = $scope.userStatusHistoryDetails[index].adminNote;

                    angular.forEach($scope.userStatusHistoryDetails, function (value, key) {
                        if (key != index) {
                            $scope.userStatusHistoryDetails[key].isShowEditButton = false;
                            $scope.userStatusHistoryDetails[key].isShowDeleteButton = false;
                        } else {
                            $scope.userStatusHistoryDetails[key].isShowCommentBox = false;
                            $scope.userStatusHistoryDetails[key].isShowTick = false;
                            $scope.userStatusHistoryDetails[key].isShowEditButton = true;
                            $scope.userStatusHistoryDetails[key].isShowDeleteButton = true;
                        }
                    });
                    enableSaveForDeprecatedUser();
                }
            }
        }

        $scope.deleteComment = function (userStatusHistory, index) {
            index = ($scope.commentDetailsCurrentPage * 3) + index
            if (!$scope.isNewStatusModelAdded) {
                if (index == 0 && $scope.userStatusHistoryDetails.length > 0) {
                    $scope.profileData.eSpectraAdminNote = $scope.userStatusHistoryDetails[1].adminNote;
                    $scope.profileData.eSpectraAdminNoteLastUpdateTS = $scope.userStatusHistoryDetails[1].statusDate;
                } else if (index == 0 && $scope.userStatusHistoryDetails.length == 0) {
                    $scope.profileData.eSpectraAdminNote = "";
                    $scope.profileData.eSpectraAdminNoteLastUpdateTS = "";
                }
            }
            if (index == 0 && $scope.isNewStatusModelAdded) {
                angular.forEach($scope.userStatusHistoryDetails, function (value, key) {
                    $scope.userStatusHistoryDetails[key].isShowEditButton = true;
                    $scope.userStatusHistoryDetails[key].isShowDeleteButton = true;
                });
            } else {
                angular.forEach($scope.userStatusHistoryDetails, function (value, key) {
                    if (index != key) {
                        $scope.userStatusHistoryDetails[key].isShowEditButton = false;
                        $scope.userStatusHistoryDetails[key].isShowDeleteButton = false;
                    }
                });
            }
            $scope.userStatusHistoryDetails.splice(index, 1);
            if ($scope.userStatusHistoryDetails.length == 0) {
                $scope.updatedAdminNoteIndex = '';
                $scope.profileData.eSpectraAdminNoteLastUpdateTS = '';
                $scope.profileData.eSpectraAdminNote = '';
                enableSaveForDeprecatedUser();
            } else {
                $scope.profileData.eSpectraAdminNoteLastUpdateTS = $scope.userStatusHistoryDetails[0].statusDate;
                $scope.profileData.eSpectraAdminNote = $scope.userStatusHistoryDetails[0].adminNote;
            }
            $scope.deletedComments = $scope.deletedComments + userStatusHistory.adminNoteId + ',';
        }

        function enableSaveForDeprecatedUser() {
            if ($scope.profileData.eSpectraSelectedUserStatus.toLowerCase() == 'deprecated') {
                if ($scope.profileData.eSpectraAdminNote.length > 0) {
                    $scope.disableSaveBtn = false;
                    $scope.profileForm.$valid = true;
                } else {
                    $scope.disableSaveBtn = true;
                    $scope.profileForm.$valid = false;
                }
            }
        }

        $scope.editIndividualStatusComment = function (index) {
            index = ($scope.commentDetailsCurrentPage * 3) + index;
            $scope.userStatusHistoryDetails[index].newAdminNote = $scope.userStatusHistoryDetails[index].adminNote;
            $scope.userStatusHistoryDetails[index].isShowCommentBox = !$scope.userStatusHistoryDetails[index].isShowCommentBox;
            $scope.userStatusHistoryDetails[index].isShowCommentError = $scope.userStatusHistoryDetails[index].isShowCommentError == true ? false : $scope.userStatusHistoryDetails[index].isShowCommentError;
            if ($scope.userStatusHistoryDetails[index].isShowCommentBox) {
                if (index != 0) {
                    $scope.userStatusHistoryDetails.splice(0, 1);
                    $scope.isNewStatusModelAdded = false;
                    index = index - 1;
                }
                angular.forEach($scope.userStatusHistoryDetails, function (value, key) {
                    if (index != key) {
                        $scope.userStatusHistoryDetails[key].isShowEditButton = false;
                        $scope.userStatusHistoryDetails[key].isShowCommentBox = false;
                        $scope.userStatusHistoryDetails[key].isShowTick = false;
                        $scope.userStatusHistoryDetails[key].isShowDeleteButton = false;
                    }
                });
            } else if ($scope.profileData.eSpectraAdminNoteLastUpdateTS != $scope.userStatusHistoryDetails[index].statusDate && $scope.profileData.eSpectraAdminNote != $scope.userStatusHistoryDetails[index].adminNote || !$scope.isTopAdminNoteUpdated) {
                angular.forEach($scope.userStatusHistoryDetails, function (value, key) {
                    $scope.userStatusHistoryDetails[key].isShowEditButton = true;
                    $scope.userStatusHistoryDetails[key].isShowDeleteButton = true;
                });
                if (!$scope.isNewStatusModelAdded) {
                    $scope.getNewStatusDetailsModel();
                    $scope.userStatusHistoryDetails.unshift($scope.newStatusDetailsModel);
                    index = index + 1;
                    $scope.isNewStatusModelAdded = true;
                }
            }
            $scope.userStatusHistoryDetails[index].isShowTick = !$scope.userStatusHistoryDetails[index].isShowTick;
            $scope.userStatusHistoryDetails[index].isShowEditButton = true;
            $scope.userStatusHistoryDetails[index].isShowDeleteButton = true;
        }

        $scope.saveAdminUpdatedUserProfile = function (currentUser) {
            if ($scope.ValidateUserDetails()) {
                var element = document.getElementById('eSpectraAdminNoteField');
                if (currentUser.eSpectraSelectedUserStatus != currentUser.eSpectraPartyStatus && currentUser.eSpectraSelectedUserStatus.toLowerCase() == 'suspended' && !$scope.isTopAdminNoteUpdated) {// && element != null && element.className.indexOf('ng-empty') != -1) {
                    if (!$scope.isTopAdminNoteUpdated && element != null) {
                        var element0 = document.getElementById('save-comment-0');
                        if (element.className.indexOf('ng-empty') != -1) {
                            element.classList.add('border-red');
                        } else {
                            element.classList.remove('border-red');
                            element0.firstChild.classList.add('untick-comment');
                        }
                    }
                    $scope.setTab(2);
                } else {
                    progressBarService.showProgressBar();
                    var userData = {
                        eSpectraFirstName: currentUser.eSpectraFirstName,
                        eSpectraLastName: currentUser.eSpectraLastName,
                        eSpectraUserStatus: currentUser.eSpectraSelectedUserStatus,
                        eSpectraUserRole: currentUser.currentUserSelectedRoleType,
                        eSpectraPersonID: currentUser.eSpectraPersonID,
                        //eSpectraAdminId: eSpectraAdminId,
                        eSpectraOrderStartDate: $scope.addMonthlySubscription == true ? $scope.userSubpackPurchaseDetails[0].eSpectraOrderStartDate.toDateString() : '',
                        eSpectraOrderIDs: $scope.deletedSubPackIds.substr(0, $scope.deletedSubPackIds.length - 1),
                        eSpectraAdminNoteIDs: $scope.deletedComments.substr(0, $scope.deletedComments.length - 1),
                        eSpectraSubPackIsAddSubscription: $scope.addMonthlySubscription == true ? 1 : 0,
                        eSpectraRecurringBillFlag: $scope.userSubpackPurchaseDetails.length != 0 && $('#on')[0].checked ? 1 : 0,
                        eSpectraCancelRecurring: $scope.userSubpackPurchaseDetails.length != 0 && $('#off')[0].checked && $scope.userCurrentSubscription.eSpectraRecurringBillFlag != 0 ? 1 : 0,
                        eSpectraPrimaryAffiliationID: parseInt(currentUser.InstitutionId) > 0 ? currentUser.InstitutionId : 1,
                        eSpectraPrimaryAffiliationName: currentUser.InstitutionName,
                        isKratosData: currentUser.isKratosData ? 1 : 0
                    }

                    if ($scope.addMonthlySubscription == true && !$scope.userSubpackPurchaseDetails[0].isExpiryDateUpdated) {
                        userData.eSpectraOrderEndDate = $scope.userSubpackPurchaseDetails[0].eSpectraOrderEndDate.toDateString();
                    } else if ($scope.userSubpackPurchaseDetails.length > 0 && $scope.userSubpackPurchaseDetails[0].isExpiryDateUpdated) {
                        userData.eSpectraOrderEndDate = $scope.userSubpackPurchaseDetails[0].eSpectraOrderEndDate;
                    } else {
                        userData.eSpectraOrderEndDate = '';
                    }

                    var newPasswordData = {
                        eSpectraEmail: '',
                        eSpectraPassword: ''
                    }

                    var userStatusData = {
                        //adminUserId: eSpectraAdminId,
                        userID: currentUser.eSpectraPersonID,
                        userFirstName: currentUser.eSpectraFirstName,
                        username: currentUser.eSpectraFullName,
                        emailID: currentUser.eSpectraEmail,
                        eSpectraAdminNote: $scope.updatedAdminNoteIndex.toString() != '' && $scope.userStatusHistoryDetails.length > 0 ? $scope.userStatusHistoryDetails[$scope.updatedAdminNoteIndex].adminNote : "",
                        statusId: '',
                        statusValue: currentUser.eSpectraSelectedUserStatus,
                        //isAdminNoteUpdated: $scope.isAdminNoteUpdated,
                        //eSpectraAdminNoteID: $scope.isAdminNoteUpdated == true ? $scope.userStatusHistoryDetails[$scope.updatedAdminNoteIndex].adminNoteId : 0,
                        eSpectraAdminNoteID: $scope.updatedAdminNoteIndex.toString() == '' ? 0 : $scope.userStatusHistoryDetails[$scope.updatedAdminNoteIndex].adminNoteId,
                        statusDate: $scope.userStatusHistoryDetails.length > 0 && $scope.updatedAdminNoteIndex.toString() != '' ? $scope.databaseDate + " " + $scope.currentTime + ":" + $scope.currentSeconds : " "
                    }

                    userManagementService.saveAdminUpdatedUserProfile(userData).then(function (response) {
                        if (response != null && response.data.message != undefined) {
                            $scope.modalMessage = response.data.message;
                            $scope.isModalError = true;
                            $scope.isModalSuccess = false;
                            // $scope.closeEditUserProfileModal();
                            progressBarService.hideProgressBar();
                        }
                        else {
                            if (response.data.cyberSourceStatus == true) {
                                if (userData.eSpectraCancelRecurring == 1 && userData.eSpectraRecurringBillFlag == 0) {
                                    $scope.isAutorenewal = 0;
                                    $scope.userCurrentSubscription.eSpectraRecurringBillFlag = 0;
                                    $('#on')[0].checked = false;
                                    angular.element(document.querySelector('#offLbl')).addClass('active');
                                    angular.element(document.querySelector('#onLbl')).removeClass('active');
                                }
                            } else if (userData.eSpectraCancelRecurring == 1 && userData.eSpectraRecurringBillFlag == 0 && response.data.cyberSourceStatus == false) {
                                $scope.modalMessage = 'Your cancellation of Auto-renewal has failed. Please contact Customer Service.';
                                $scope.isModalError = true;
                                $scope.isModalSuccess = false;
                                $scope.isAutorenewal = 1;
                                $('#on')[0].checked = true;
                                angular.element(document.querySelector('#offLbl')).removeClass('active');
                                angular.element(document.querySelector('#onLbl')).addClass('active');
                            }

                            $scope.saveIndividualStatusDetails(currentUser.index, userStatusData, currentUser.eSpectraPartyStatus);
                        }
                    });
                }
            }
        }

        $scope.saveIndividualStatusDetails = function (index, userStatusData, eSpectraUserStatus) {
            progressBarService.showProgressBar();
            if (userStatusData.statusValue.toLowerCase() == eSpectraUserStatus.toLowerCase() && userStatusData.eSpectraAdminNote == "") {
                $scope.changePassword();
            } else {
                angular.forEach($scope.status, function (value, key) {
                    if (value.eSpectraTypeItemName == userStatusData.statusValue) {
                        userStatusData.statusId = value.eSpectraTypeID;
                    }
                });
                userManagementService.updateStatus(userStatusData).then(function (response) {
                    if (response != null && response.data.message != undefined) {
                        $scope.message = response.data.message;
                        $scope.isError = true;
                        $scope.isSuccess = false;
                        $scope.closeEditUserProfileModal();
                        progressBarService.hideProgressBar();
                    }
                    else {
                        if (userStatusData.statusValue.toLowerCase() === 'suspended')
                            $scope.sendSuspendedUserAccountMailtoUser(userStatusData.emailID, userStatusData.userFirstName);
                        if (userStatusData.statusValue.toLowerCase() === 'deprecated')
                            $scope.sendDeletedUserAccountMailtoUser(userStatusData.emailID, userStatusData.userFirstName);
                        $scope.changePassword();
                    }

                });
            }
        }

        $scope.sendSuspendedUserAccountMailtoUser = function (emailID, userFirstName) {
            userManagementService.sendSuspendedUserAccountMailtoUser(emailID, userFirstName);
        }

        $scope.sendDeletedUserAccountMailtoUser = function (emailID, userFirstName) {
            userManagementService.sendDeletedUserAccountMailtoUser(emailID, userFirstName);
        }

        $scope.changePassword = function () {

            var data = {
                eSpectraEmail: $scope.profileData.eSpectraEmail,
                eSpectraPassword: $scope.profileData.registeredPassword
            }
            if (data.eSpectraPassword == "") {
                $scope.isSuccess = true;
                $scope.message = "Profile has been updated successfully for user with email id '" + data.eSpectraEmail + "'";
                $scope.getData();;
            } else {
                userManagementService.resetPassword(data).then(function (response) {
                    if (response != null && response.data.message != undefined) {
                        $scope.modalMessage = response.data.message;
                        $scope.isModalError = true;
                        $scope.isModalSuccess = false;
                        $scope.closeEditUserProfileModal();
                        progressBarService.hideProgressBar();
                    }
                    else {
                        $scope.isSuccess = true;
                        senNotification(data);
                        $scope.message = "Profile has been updated successfully for user with email id '" + data.eSpectraEmail + "'";
                        $scope.getData();
                    }
                });
            }
        }

        var senNotification = function (data) {
            userManagementService.notificationSuperadminChangePassword(data);
        };

        $scope.ValidateUserDetails = function () {
            var returnVal = true;
            if (angular.element("#eSpectraLastName").val() != '') {
                $("#eSpectraLastName").removeClass("border-red");
                $("#eSpectraLastName").siblings('span').find("span.error-msg").addClass('display-none')
                var regExp = /^[a-zA-Z](?!.*-.*-.*)(?!.*\s.*\s.*)[a-zA-Z- ]+$/;
                var isValid = regExp.test(angular.element("#eSpectraLastName").val());
                if (isValid) {
                    $("#eSpectraLastName").removeClass("border-red");
                    $("#eSpectraLastName").siblings('span').find("span.error-msg").addClass('display-none')
                }
                else {
                    if (returnVal) {
                        $("#eSpectraLastName").focus();
                    }
                    $("#eSpectraLastName").siblings('span').find("span.error-msg").removeClass('display-none')
                    returnVal = false;
                }
            }
            else {
                //$("#eSpectraLastName").addClass("border-red");
                if (returnVal) {
                    $("#eSpectraLastName").focus();
                }
                $("#eSpectraLastName").siblings('span').find("span.error-msg").removeClass('display-none')
                returnVal = false;
            }

            if (!returnVal) {
                this.profileForm.eSpectraLastName.$dirty = true;
            }

            return returnVal;
        }

        $scope.editIndividualSubPackEndDate = function (index) {
            $scope.userSubpackPurchaseDetails[index].isExpiryDateEditable = !$scope.userSubpackPurchaseDetails[index].isExpiryDateEditable;
            $scope.isWrongExpiryDate = false;
        }

        $scope.showNextPurchaseDetailsPage = function () {
            $scope.purchaseDetailscurrentPage = $scope.purchaseDetailscurrentPage + 1;
            $scope.userSubpackPurchaseDetails[0].isExpiryDateEditable = false
        }

        $scope.showNextCommentDetailsPage = function () {
            $scope.commentDetailsCurrentPage = $scope.commentDetailsCurrentPage + 1;
        }

        $scope.deleteSubpack = function (purchaseData, $index) {
            $scope.isShowAddSubPackIcon = true;
            $scope.userSubpackPurchaseDetails.splice($index, 1);
            $scope.deletedSubPackIds = $scope.deletedSubPackIds + purchaseData.eSpectraOrderID + ',';
            if ($scope.userSubpackPurchaseDetails.length != 0) {
                document.getElementById('edit-' + ($index + 1)).classList.remove('ng-hide');
                document.getElementById('delete-' + ($index + 1)).classList.remove('ng-hide');
                document.getElementById('save-' + ($index + 1)).classList.remove('ng-hide');
            }
        }

        $scope.addMonthlySubscriptionPack = function () {
            $scope.activeTab = 1;
            $scope.isShowAddSubPackIcon = false;
            $scope.addMonthlySubscription = true;
            var newSubStartDate, eSpectraExpiryDate, newSubExpiryDate, todayDate;
            todayDate = new Date();
            todayDate.setHours(0, 0, 0, 0);
            if ($scope.userSubpackPurchaseDetails.length != 0) {
                eSpectraExpiryDate = new Date($scope.userSubpackPurchaseDetails[0].eSpectraOrderEndDate);
                eSpectraExpiryDate.setHours(0, 0, 0, 0);
                if (todayDate <= eSpectraExpiryDate) {
                    $scope.userSubpackPurchaseDetails[0].isExpiryDateEditable = $scope.userSubpackPurchaseDetails[0].isExpiryDateEditable == true ? false : '';
                    newSubStartDate = new Date(eSpectraExpiryDate.setDate(eSpectraExpiryDate.getDate() + 1));
                    newSubExpiryDate = new Date(eSpectraExpiryDate.setMonth(eSpectraExpiryDate.getMonth() + 1));
                } else {
                    newSubStartDate = new Date();
                    newSubExpiryDate = new Date(todayDate.setMonth(todayDate.getMonth() + 1));
                }
            } else {
                newSubStartDate = new Date();
                newSubExpiryDate = new Date(todayDate.setMonth(todayDate.getMonth() + 1));
            }
            var newSubscription = {
                eSpectraSubPackPlanType: 'Monthly',
                premiumType: 'Premium',
                eSpectraOrderStartDate: newSubStartDate,
                eSpectraOrderEndDate: newSubExpiryDate
            }
            $scope.userSubpackPurchaseDetails.unshift(newSubscription);
        }

        $scope.removeMonthlySubscriptionPack = function () {
            $scope.activeTab = 1;
            $scope.addMonthlySubscription = false;
            $scope.isShowAddSubPackIcon = true;
            $scope.userSubpackPurchaseDetails.splice(0, 1);
        }

        $scope.viewAnalytics = function (emailId) {
            $rootScope.eSpectraUserAnalyticsEmailID = emailId;
            $location.path('/admin/storagemanagement');
        }

        $scope.viewTransactions = function (emailId) {
            $rootScope.eSpectraUserTransactionsEmailID = emailId;
            $location.path('/subscriptionReport');
        }

        $scope.updateIndividualSubPackEndDate = function (index) {
            var newExpiryDate = new Date($('#eSpectraExpiryDate').val());
            var cureentStartDate = new Date($scope.userSubpackPurchaseDetails[index].eSpectraOrderStartDate)
            var cureentExpiryDate = new Date($scope.userSubpackPurchaseDetails[index].eSpectraOrderEndDate)
            cureentExpiryDate = (cureentExpiryDate.getMonth() + 1) + '-' + cureentExpiryDate.getDate() + '-' + cureentExpiryDate.getFullYear();
            var todayDate = new Date();
            if (newExpiryDate >= todayDate && cureentStartDate < newExpiryDate && cureentExpiryDate != $('#eSpectraExpiryDate').val()) {
                $scope.userSubpackPurchaseDetails[index].eSpectraOrderEndDate = $('#eSpectraExpiryDate').val();
                $scope.userSubpackPurchaseDetails[index].isExpiryDateEditable = false;
                $scope.userSubpackPurchaseDetails[index].isExpiryDateUpdated = true;
                $scope.isWrongExpiryDate = false;
            } else {
                $scope.isWrongExpiryDate = true;
            }
        }

        $scope.hideWrongExpiryDateMessage = function () {
            $scope.isWrongExpiryDate = false;
        }

        $scope.selectAffiliation = function () {

            $('#affiliationName').val('');
            $scope.isAffiliationDivActive = true;
            $scope.selectedInstitute.userDefinedAffiliation = "";
            $scope.selectedInstitute.InstitutionId = $scope.profileData.InstitutionId;
            if (!$scope.selectedInstitute.isAffiliationExists) {
                $scope.selectedInstitute.InstitutionName = $scope.profileData.eSpectraPrimaryAffiliationName;
                $scope.selectedInstitute.InstitutionName = $scope.profileData.eSpectraPrimaryAffiliationName;
            } else {
                if ($scope.profileData.eSpectraPrimaryAffiliationName.length == 0) {
                    $scope.selectedInstitute.isAffiliationExists = false
                    //$('#affiliationName').removeAttr('disabled');
                }
                $scope.selectedInstitute.userDefinedAffiliation = $scope.profileData.eSpectraPrimaryAffiliationName;
            }

            $('#affiliation').modal('show');
        }

        $scope.downloadStatusHistory = function () {

            progressBarService.showProgressBar();
            var today, dd, mm, yyyy, currentDate, startDate, endDate, parameter;
            today = new Date();
            dd = today.getDate();
            mm = today.getMonth() + 1; //January is 0!

            yyyy = today.getFullYear();
            if (dd < 10) {
                dd = '0' + dd;
            }
            if (mm < 10) {
                mm = '0' + mm;
            }
            currentDate = mm + '/' + dd + '/' + yyyy;

            var data = {
                eSpectraPersonID: $scope.personId
            }

            userManagementService.getUserHistory(data).then(function (response) {
                if (response != null && response.data.message != undefined) {
                    $scope.modalMessage = response.data.message;
                    $scope.isModalError = true;
                    $scope.isModalSuccess = false;
                }
                else {
                    var csv = UserHistory_ConvertArrayOfObjectsToCSV({
                        data: response.data
                    });

                    BlobDownloadCSV('UserStatusHistory_' + currentDate + '.csv', csv)

                }

                progressBarService.hideProgressBar();
            });
        }

        function UserHistory_ConvertArrayOfObjectsToCSV(args) {

            var result, ctr, keys, columnDelimiter, lineDelimiter, data, headers;

            data = args.data || null;
            if (data == null || !data.length) {
                return null;
            }

            columnDelimiter = args.columnDelimiter || ',';
            lineDelimiter = args.lineDelimiter || '\n';

            keys = Object.keys(data[0]).slice(1);

            headers = ["Admin Name",
                "Status",
                "Admin Note",
                "Status Date"
            ]

            result = 'Report Name' + columnDelimiter + "User Status History Report" + lineDelimiter;

            result += headers.join(columnDelimiter);
            result += lineDelimiter;

            data.forEach(function (item) {

                ctr = 0;
                keys.forEach(function (key) {
                    if (ctr > 0) result += columnDelimiter;

                    result += item[key];
                    ctr++;
                });
                result += lineDelimiter;
            });

            return result;
        }

        $scope.setTab = function (tab) {
            $scope.activeTab = tab;
        }

        $scope.checkLenghtOfComment = function (index) {
            if ($scope.userStatusHistoryDetails[index].newAdminNote.length <= 500) {
                $scope.userStatusHistoryDetails[index].isShowCommentError = false
                $scope.isCommentError = false;
            } else {
                $scope.userStatusHistoryDetails[index].isShowCommentError = true;
                $scope.isCommentError = true;
            }
        }

        $scope.closeEditUserProfileModal = function () {
            $('#editUserProfileModal').modal('hide');
            $('div.modal-backdrop').remove();
        }

    }]);
})();